import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellDateAndTime.styles';
import { Typography } from '../../../base-components';
import { formatDateAndTime } from '../../table.utils';
import { EMPTY_CELL } from '../../../../common';

interface Props extends IBaseCellsProps {
    data: { text: string };
}
const CellDateAndTime = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        data,
    } = props;
    const { date, time } = formatDateAndTime(data.text);
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            {date ? (
                <>
                    <Typography variant={'body2'}>{date}</Typography>
                    {time && <Typography variant={'body2'}>{time}</Typography>}
                </>
            ) : (
                <Typography variant={'body2'}>{EMPTY_CELL}</Typography>
            )}
        </StyledTableCell>
    );
};

export default CellDateAndTime;
